import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export type AnnouncementSeverity = 'info' | 'warning' | 'error';

export interface AnnouncementConfig {
  enabled: boolean;
  id?: string;
  title?: string;
  message?: string;
  severity?: AnnouncementSeverity;
  dismissible?: boolean;
}

export const announcementApi = {
  async getAnnouncement(): Promise<AnnouncementConfig> {
    const response = await axios.get(`${API_URL}/api/public/announcement`);
    return response.data;
  },
};
